import { ArrowRightIcon } from 'lucide-react';
import { images, serviceLinks } from '../data/site';
import { SiteLink } from './SiteLink';
export function ServiceCare() {
  return <section aria-labelledby="service-heading" className="w-full bg-ink" data-id="element-192" data-mp="2551fck670zqs">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-14" data-id="element-193" data-mp="2j49g3hi08fx3">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-194" data-mp="2f0uw6fqy3fed">
          <div className="lg:col-span-7" data-id="element-195" data-mp="2t0cjsrsi8mm5">
            <p className="text-[14px] font-bold uppercase text-water" data-id="element-196" data-mp="2sz1e2mfi14se">Service &amp; Spa Care</p>
            <h2 id="service-heading" className="mt-2 text-h2-mobile font-semibold text-white lg:text-h2-desktop" data-id="element-197" data-mp="2o19jtlrdt6l1">
              Support for Every Season of Spa Ownership
            </h2>
            <p className="mt-4 max-w-2xl text-body text-white/85 sm:text-body-lg" data-id="element-198" data-mp="2xtymps8v9c4r">
              Buying the spa is only the beginning. Pegasus helps customers with service, repairs,
              maintenance questions, spa care, replacement covers and the everyday details that keep
              ownership enjoyable.
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-x-8 sm:grid-cols-2" data-id="element-199" data-mp="1g8st8pupbyrw">
              {serviceLinks.map(link => <li key={link.label} className="border-b border-white/20" data-id="element-200" data-mp="1l7w0mgy5mh31">
                  <SiteLink to={link.href} className="flex min-h-[52px] items-center justify-between gap-3 text-[16.5px] font-medium text-white transition-colors duration-150 ease-out hover:text-water" data-id="element-201" data-mp="1q81u82nzidnr">
                    {link.label}
                    <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-202" data-mp="23ywuwrobxog9" />
                  </SiteLink>
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-5" data-id="element-203" data-mp="2dxmdkmo1vcxk">
            <div className="aspect-[3/2] w-full overflow-hidden rounded-card" data-id="element-204" data-mp="2dynnuox8rve8">
              <img src={images.service} alt="Open rear doors of a service van stocked with spa filters, parts and hoses on a residential driveway" className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-205" data-mp="2hy67zih8o2g0" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}